import { login } from '@betty/auth';
import { startListening, trackEvent } from '@betty/toolkit/state';
import { getAccount } from '@betty/account/state';
import { logInfo } from '@betty/toolkit/logging';
import { fetchRegistrationConfig } from '@betty/registration/state';
import { initAnalytics } from './analytics.utils';
import { jwtDecode } from 'jwt-decode';

const analytics = initAnalytics();

if (analytics && !__DEV__) {
  startListening({
    actionCreator: login.fulfilled,
    effect: (action) => {
      const profile = jwtDecode(action.payload.id_token);

      if (profile.sub) {
        analytics.setUserId(profile.sub);
      }
    },
  });

  startListening({
    actionCreator: getAccount.fulfilled,
    effect: (action) => {
      analytics.setUserProperties({
        accountStatus: action.payload.status,
        isTestAccount: String(action.payload.isTestAccount),
      });
    },
  });

  startListening({
    actionCreator: trackEvent,
    effect: (action) => {
      analytics.logEvent(action.payload.name, action.payload.params);
    },
  });

  startListening({
    actionCreator: fetchRegistrationConfig.fulfilled,
    effect: (action) => {
      analytics.setUserProperties({
        registrationConfigId: action.payload.id,
      });
    },
  });

  const blacklistedActions = [
    'persist',
    'tracking',
    'activity',
    'jackpots',
    'globalContext',
    'globalAlert/fetch/pending',
    'globalAlert/fetch/fulfilled',
  ];

  type MetaArgType = number | string | boolean | undefined;
  type MetaType = { arg?: MetaArgType };

  startListening({
    predicate: ({ type }) =>
      !blacklistedActions.find((action) => type.match(action)),
    effect: (action, { dispatch }) => {
      const meta = action.meta as MetaType; // TODO: Check for better solution

      dispatch(
        trackEvent({
          name: 'state_event',
          params: {
            stateEventType: action.type,
            stateEventArg: (typeof meta?.arg).match('number|string|boolean')
              ? meta?.arg
              : '',
          },
        }),
      );
    },
  });

  if (__DEV__) {
    startListening({
      actionCreator: trackEvent,
      effect: (action) => {
        logInfo('Tracking', action.payload);
      },
    });
  }
}
